import template from './filterButton.html';

let component = {
	template,
	controller: function(Filter) {
		"ngInject";

		var vm = this;

		vm.openFilters = function() {
			Filter.openFilters();
		}
	}
};

export default component;


// WEBPACK FOOTER //
// ./app/components/filterButton/filterButton.component.js